// extracted by mini-css-extract-plugin
export default {"main":"Input_main__XwVq7"};